export default {
  previewTitle: 'Sin título',
  backToKrea: 'Volver a Krea'
}

export const en = {
  previewTitle: 'Untitled',
  backToKrea: 'Return to Krea'
}

export const ca = {
  previewTitle: 'Sense títol',
  backToKrea: 'Tornar a Krea'
}
